import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { WarningAlert } from 'components/Alerts';
import { WideLink } from 'components/Typography';

export interface PaymentMethodUpdateRequiredProps {
  updatePaymentMethodUrl: string;
}

export const PaymentMethodUpdateRequired = ({ updatePaymentMethodUrl }: PaymentMethodUpdateRequiredProps) => (
  <WarningAlert>
    <WarningAlert.Heading>
      We do not currently have your credit card details on file and are unable to complete your payment.
    </WarningAlert.Heading>
    <WarningAlert.Body>
      Please update your payment details for each booking within 7 days of payment being due, or your booking may be cancelled. Payment
      details must be updated before any changes or cancellations can be made
    </WarningAlert.Body>

    <WideLink
      mt={2}
      color="brand.primary"
      underline={true}
      data-testid="payment-method-update-required-alert"
      to={updatePaymentMethodUrl}
      onClick={tracking.updatePaymentDetailsAlertSelected}
    >
      Update payment details
    </WideLink>
  </WarningAlert>
);
